import { Globals } from '@/modules/Globals';
import axios from 'axios';

export class WhatsNewService {
  /** Persists an announcement as seen for the logged user (all devices). */
  static async markSeen(id: string): Promise<{ seenWhatsNew: string[] }> {
    const res = await axios.put<{ seenWhatsNew: string[] }>(
      `${Globals.apiPath}/auth/whats-new`,
      { id }
    );
    return res.data;
  }
}
